import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

interface ContactSupportModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const Context = createContext<ContactSupportModalContextType | undefined>(undefined);

interface ContactSupportModalProviderProps {
  children: ReactNode;
}

export const ContactSupportModalProvider = ({ children }: ContactSupportModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, openModal, closeModal }), [isOpen, openModal, closeModal]);

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useContactSupportModal = (): ContactSupportModalContextType => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useContactSupportModal must be used within a ContactSupportModalProvider');
  }
  return context;
};
